<template>
  <div class="privacy-policy-wrapper">
    <div id="navbar" :class="{ backgroundi: show }">
      <div class="nav-brand" data-aos="zoom-in" data-aos-duration="1500">
        <router-link to="/" data-aos="zoom-in" data-aos-duration="1500">
          <img style="height: 50px" src="../assets/new-logo.svg" alt="" />
        </router-link>
        <b-icon-list scale="2" class="fa fa-navicon" v-on:click="display"></b-icon-list>
      </div>

      <div class="bar-items" :class="{ hide: !show }">
        <div id="menu" data-aos="zoom-in" data-aos-duration="1500">
          <RouterLink to="/">{{$t("Home")}}</RouterLink>

          <RouterLink to="/services">{{$t("Services")}}</RouterLink>

          <RouterLink to="/aboutUs">{{$t("About")}}</RouterLink>

          <RouterLink to="/contact">{{$t("Contact")}}</RouterLink>
          <div class="language-selector">
            <b-dropdown id="dropdown" drop color="black">
              <template #button-content>
                <b-icon icon="globe" style="width:25px; height:30px;"></b-icon>
              </template>
              <b-dropdown-item @click="changeL('de')">Deutsch</b-dropdown-item>
              <b-dropdown-item @click="changeL('en')">English</b-dropdown-item>
              <b-dropdown-item @click="changeL('fr')">French</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid privacy-policy-text-wrapper">
      <h1 class="text-center mb-5">{{ $t('PrivacyPolicy') }}</h1>
      <p>Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Bearbeitung von Personendaten über diese Website sowie externe Onlinepräsenzen, wie z.B. Social Media auf.</p>
      <p>Der betriebliche Datenschutzbeauftragte kann unter folgender</p>
      <p>Adresse kontaktiert werden:&nbsp;<a href="mailto:contact@dslogistik.ch" class="email">contact@dslogistik.ch</a></p>
      <p><strong>Kategorien der bearbeiteten Personendaten</strong></p>
      <p>Wir bearbeiten folgende Kategorien von Personendaten:</p>
      <ul>
        <li>Daten zu Ihrer Person (z.B. Namen, Mitgliednummer, Namen von Familienmitgliedern, Alter).</li>
        <li>Kontaktdaten (z.B. Adressen, E-Mail, Telefonnummern).</li>
        <li>Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos).</li>
        <li>Finanzielle Daten (insb. Kreditkarte, Guthaben, und Gutscheine)</li>
        <li>Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten).</li>
        <li>Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen).</li>
        <li>weitere von Ihnen zur Verfügung gestellte Angaben und Informationen</li>
      </ul>
      <p><strong>Zwecke der Bearbeitung</strong></p>
      <p>Wir bearbeiten Ihre Personendaten zu folgenden Zwecke:</p>
      <ul>
        <li>Vermietung von Wohnungen</li>
        <li>Organisieren von Events</li>
        <li>Abschluss und Erfüllen von Verträgen</li>
        <li>Webseite anzuzeigen</li>
        <li>Onlinekanäle, seine Funktionen und Inhalte zu betreiben</li>
        <li>Interaktion mit Ihnen sicherzustellen</li>
        <li>Kommunikation und Tracking der Kommunikation</li>
        <li>IT-Testing/IT-Entwicklung</li>
        <li>Sicherheit</li>
      </ul>
      <p>Wir bearbeiten Ihre Personendaten ausserdem für nicht personenbezogene Zwecke, insbesondere für</p>
      <ul>
        <li>Statistiken</li>
        <li>Reportings, Auswertungen</li>
      </ul>
      <p>Wir bearbeiten Ihre Personendaten schliesslich zu den Zwecken, für welche Sie gegebenenfalls Ihre Einwilligung gegeben haben, wie</p>
      <ul>
        <li>Tracking bei Cookies und Pixels (ausser erforderliche Cookies)</li>
      </ul>
      <p>Sie könne die Cookies jederzeit bei sich im Browser löschen.</p>
      <p><strong>Kategorien der Empfänger der Personendaten</strong></p>
      <p>Ihre Personendaten werden an die folgenden Kategorien von Verantwortlichen weitergegeben:</p>
      <ul>
        <li>Webseiten- und Onlinekanäle-Dienstleistungsunternehmen, insbesondere:
          <ul>
            <li>Google Ireland Limited, Ireland</li>
            <li>Cloudflare Inc., USA</li>
            <li>LinkedIn Ireland Unlimited Company, Ireland</li>
            <li>Meta Platforms Ireland Limited, Ireland</li>
          </ul>
        </li>
      </ul>
      <p>Die Datenschutzerklärungen der Webseiten- und Onlinekanäle-Dienstleistungsunternehmen befinden sich auf den Webseiten dieser Unternehmen. K&amp;P ImmobilienTreuhand GmbH hat keinen Einfluss auf diese Datenschutzerklärungen und kann über deren Datenbearbeitungen nicht informieren.</p>
      <p>Ihre Personendaten werden an die folgenden Kategorien von Dienstleistungsunternehmen weitergegeben:</p>
      <ul>
        <li>Provider von Marketing-Kommunikation</li>
        <li>Provider von IT-Lösungen</li>
        <li>Übliche IT-Provider und IT-Dienstleistungsunternehmen</li>
      </ul>
      <p><strong>Wo werden Ihre Daten bearbeitet?</strong></p>
      <p>Ihre Personendaten werden in der Schweiz, in den Mitgliedstaaten der EU und des EWR und im Vereinigten Königreich bearbeitet. Das angemessene Datenschutzniveau dieser Länder ergibt sich aus den Feststellungen des Bundesrats.</p>
      <p><strong>Was sind Ihre Rechte?</strong></p>
      <p>Sie haben folgende Rechte gemäss dem Datenschutzgesetz:</p>
      <ul>
        <li>Recht auf Auskunft</li>
        <li>Recht auf Berichtigung</li>
        <li>Recht auf Widerspruch gegen unsere Datenbearbeitung</li>
        <li>Recht auf Datenherausgabe oder Datenübertragung</li>
      </ul>
      <p>Um Ihre Rechte auszuüben, können Sie uns unter der folgenden Adresse kontaktieren:&nbsp;<a href="mailto:contact@dslogistik.ch" class="email">contact@dslogistik.ch</a></p>
      <p><strong>Änderungen dieser Datenschutzerklärung</strong></p>
      <p>Der Inhalt der vorliegenden Datenschutzerklärung kann jederzeit geändert werden.</p>
      <p>Letzte Aktualisierung: März 2025</p>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters(["getLanguage"]),
    language() {
      if (this.getLanguage === "en") {
        return "English";
      } else if (this.getLanguage === "de") {
        return "Deutsch";
      } else if (this.getLanguage === "it") {
        return "Italian";
      } else if (this.getLanguage === "fr") {
        return "French";
      }
      return "Shqip";
    },
  },
  methods: {
    ...mapActions(["changeLanguage"]),

    changeL(lang) {
      this.changeLanguage(lang);
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang;
      }
    },

    display() {
      this.show = !this.show;
    },
  },
  name: "PrivacyPolicy"
}
</script>

<style scoped>
@import "../assets/style/service.scss";
.privacy-policy-text-wrapper {
  margin: 40px 0;
  font-family: 'Poppins', sans-serif;
}
#navbar {
  background-color: #112432 !important;
  padding: 15px 0;
}
.fa.fa-navicon {
  display: none;
}

.content p {
  text-align: center;
  font: normal normal normal 25px/33px Poppins;
  letter-spacing: -1.25px;
  color: #ffffff;
  opacity: 1;
}
.button button {
  width: 297px;
  height: 53px;
  /* UI Properties */
  background: #008eff 0% 0% no-repeat padding-box;
  opacity: 1;
  /* UI Properties */
  font: normal normal bold 19px/26px Poppins;
  letter-spacing: 0.38px;
  color: #ffffff;
  /* margin-left: 230px; */
  margin-top: 10px;
}

nav {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 10px;
}

nav ul li {
  list-style-type: none;
  display: inline-block;
  padding: 10px 20px;
}

nav ul li a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}
@media screen and (max-width: 1741px) {
}
@media screen and (max-width: 1441px) {
}
@media screen and (max-width: 1200px) {
}
@media screen and (max-width: 1100px) {
}
@media screen and (max-width: 900px) {
}
@media screen and (max-width: 768px) {
}
@media (max-width: 780px) {
  .b-icon.bi {
    display: inline-block;
  }
  #navbar {
    flex-direction: column;
  }
  .backgroundi {
    background-color: rgb(99, 99, 99) !important;
  }
  .fa {
    display: block;
    padding: 0 25px;
    position: absolute;
    right: 0;
    color: #fff;
    font-size: 30px;
    cursor: pointer;
    margin-top: 30px;
  }

  #menu {
    flex-direction: column;
    padding: 5px 0;
  }

  a {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
  }

  .hide {
    display: none;
  }

  .nav-brand {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 15px 0px; */
  }
}
@media screen and (max-width: 568px) {
}
@media screen and (max-width: 430px) {
}

#navbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: transparent;
  width: 100%;
}

#menu {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: 0 !important;
  padding: 0;
  /* margin-bottom: -24px; */
  margin-top: 30px;
}

a {
  padding: 20px;
}

a {
  text-decoration: none;
  font-size: 18px;
  color: #fff !important;
  white-space: nowrap;
}

.fa {
  display: none;
}

@media screen and (max-width: 415px) {
}
@media screen and (max-width: 390px) {
  .b-icon.bi {
    display: inline-block;
  }
}
.email {
  color: blue !important;
}
</style>
